import { render, staticRenderFns } from "./CaptureLicenseBack.vue?vue&type=template&id=bc58226c&scoped=true&"
import script from "./CaptureLicenseBack.vue?vue&type=script&lang=ts&"
export * from "./CaptureLicenseBack.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureLicenseBack.vue?vue&type=style&index=0&id=bc58226c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58226c",
  null
  
)

export default component.exports